/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_RtpInputs */



/**
* | output |
* | --- |
* | "Rating Points" |
*
* @param {League_Standings_RtpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_rtp = /** @type {((inputs?: League_Standings_RtpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_RtpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de Rating")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de Rating")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de Rating")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punti Rating")
	return /** @type {LocalizedString} */ ("Rating Points")
});